<template>
  <Swiper
    :swiperOptions="swiperOptions"
    class="filtered-courses"
    :parentClass="swiperClass"
  >
    <template v-if="filter === 'Learning Paths'">
      <LearningPathTile
        v-for="item in content"
        class="swiper-slide"
        :key="item.objectID"
        :path="item"
        :customClass="`filtered-courses__content`"
      />
    </template>
    <template v-else>
      <div
        v-for="item in content"
        :key="item.objectID"
        class="filtered-courses__content swiper-slide"
      >
        <CourseTile :course="item" :isFreeTrialUser="isFreeTrialUser" />
      </div>
    </template>
  </Swiper>
</template>

<script>
import Swiper from '@/components/layout/Swiper.vue'
import CourseTile from '@/components/layout/CourseTile.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'

export default {
  name: 'FilteredCourses',
  components: {
    Swiper,
    CourseTile,
    LearningPathTile,
  },
  props: {
    filter: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    swiperClass: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        loop: false,
        freeMode: true,
        spaceBetween: 5,
        mousewheel: {
          forceToAxis: true,
        },
      },
    }
  },
}
</script>

<style lang="scss">
.filtered-courses {
  &__content {
    width: 350px;
    .course-tile__tile-top {
      min-height: 95px;
    }
    .path-tile__primary {
      height: 175px;
    }
  }
}
</style>
